export const UNITS_LANGUAGE = ['DE', 'EN'] as const;

export const UNIT_TYPE = [
  'amount',
  'area',
  'currency',
  'length',
  'temperature',
  'time',
  'volume',
  'weight',
  'weight_per_volume',
] as const;
